import React from 'react';
import {useScrollOnReveal} from '../../../../../utilities/hooks/useScrollOnReveal/useScrollOnReveal';

interface ConditionalFieldProps {
  show: boolean;
  children: React.ReactNode;
}

export const ConditionalField: React.FC<ConditionalFieldProps> = ({
  show,
  children,
}) => {
  const scrollRef = useScrollOnReveal(show);

  if (!show) return null;

  return <div ref={scrollRef}>{children}</div>;
};
